import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { INaturezaFinanceira } from '../model/natureza_financeira.model';

@Injectable()
export class NaturezaFinanceiraService extends EntityService<
  INaturezaFinanceira
> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'natureza_financeira',
        urlBackend: configService.backendURL
      }
    );
  }
}
